const BASE_TYPE_THEMES = {
  accommodations: {
    key: 'accommodations',
    apiValue: 'unterkunft',
    label: 'Unterkünfte',
    shortLabel: 'Unterkunft',
    eyebrow: 'Basisbereich',
    primary: '#ff954c', //'#d35500',
    secondary: '#ff954c',
    soft: '#fff3df',
    surface: '#fffaf1',
    border: '#f1cf9c',
    text: '#10273d',
    icon: 'fa-pro-solid:house',
  },
  offers: {
    key: 'offers',
    apiValue: 'angebote',
    label: 'Angebote',
    shortLabel: 'Angebot',
    eyebrow: 'Aktionsbereich',
    primary: '#008bc5', //'#0a5c80',
    secondary: '#008bc5',
    soft: '#e8f0f7',
    surface: '#f4fbfb',
    border: '#b9dae9',
    icon: 'fa-pro-solid:tags',
  },
  events: {
    key: 'events',
    apiValue: 'termine',
    label: 'Veranstaltungen',
    shortLabel: 'Veranstaltung',
    eyebrow: 'Terminbereich',
    primary:  '#d45ca9', //'#983b77',
    secondary: '#d45ca9',
    soft: '#f7ecfa',
    surface: '#fbf8ff',
    border: '#e3c5d8',
    text: '#10273d',
    icon: 'fa-pro-solid:calendar-day',
  },
  discover: {
    key: 'discover',
    apiValue: 'entdecken',
    label: 'Entdecken',
    shortLabel: 'Eintrag',
    eyebrow: 'Entdeckungsbereich',
    primary: '#0c9171', //'#026048',
    secondary: '#0c9171',
    soft: '#edf7f0',
    surface: '#f5fbf7',
    border: '#b9dcc4',
    text: '#10273d',
    icon: 'fa-pro-solid:compass',
  },
}

const ROUTE_PREFIX_TO_BASE_TYPE = {
  accommodations: 'accommodations',
  offers: 'offers',
  events: 'events',
  discover: 'discover',
}

const API_VALUE_TO_BASE_TYPE = Object.values(BASE_TYPE_THEMES).reduce((themes, theme) => ({
  ...themes,
  [theme.apiValue]: theme.key,
}), {})

const BASE_TYPE_ALIASES = {
  angebote: 'offers',
  termine: 'events',
  entdecken: 'discover',
  unterkunft: 'accommodations',
  accommodation: 'accommodations',
  objects: 'accommodations',
}

export function resolveBaseTypeKey(value) {
  if (typeof value === 'object' && value !== null) {
    return resolveBaseTypeKey(value.base_type ?? value.baseType ?? value.route ?? value.name)
  }

  if (typeof value !== 'string') {
    return 'accommodations'
  }

  const routePrefix = value.split('.')[0]
  return BASE_TYPE_THEMES[value]?.key
    || ROUTE_PREFIX_TO_BASE_TYPE[routePrefix]
    || API_VALUE_TO_BASE_TYPE[value]
    || BASE_TYPE_ALIASES[value]
    || 'accommodations'
}

export function getBaseTypeTheme(value) {
  return BASE_TYPE_THEMES[resolveBaseTypeKey(value)]
}

export function getBaseTypeThemeStyle(value) {
  const theme = getBaseTypeTheme(value)

  return {
    '--base-type-primary': theme.primary,
    '--base-type-secondary': theme.secondary,
    '--base-type-soft': theme.soft,
    '--base-type-surface': theme.surface,
    '--base-type-border': theme.border,
    '--base-type-text': theme.text,
  }
}

export function getBaseTypeThemeClass(value) {
  return `base-type-${resolveBaseTypeKey(value)}`
}

export function getBaseTypeIndexRoute(value) {
  return `${resolveBaseTypeKey(value)}.index`
}

export {BASE_TYPE_THEMES}
